import React from "react";
import { motion } from "framer-motion";
import { User, Loader2 } from "lucide-react";

interface TypingIndicatorProps {
  name?: string;
}

export const TypingIndicator: React.FC<TypingIndicatorProps> = ({ name }) => (
  <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    className="flex items-center gap-2"
  >
    <User className="w-5 h-5 text-gray-500 dark:text-gray-400 animate-pulse" />
    <div className="text-sm text-gray-500 dark:text-gray-400">
      {name ? `${name} is typing` : "typing"}
      <Loader2 className="inline-block w-4 h-4 ml-1 animate-spin" />
    </div>
  </motion.div>
);
